<div class="row">
    <div class="dialog-title">
        <span class="text-fw-700">Drawdown summary | </span>Please check carefully before proceeding
    </div>
</div>
<div class="row">
    <p class="text-dark-blue">By proceeding you will create the following trade:</p>
</div>
<div class="row">
    <div class="col-12 trade-drawdown px-0">
        <div class="drawdown-title">
            Drawdown trade number
        </div>
        <div class="drawdown-value">
            {{ tradeDrawdownCurrent?.tradeReference }}
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12 col-md-6 trade-drawdown left-panel pl-0">
        <div class="drawdown-title">
            You now need to pay a total of
        </div>
        <div class="drawdown-value">
            <span class="{{ tradeDrawdownCurrent?.sellCurrencyCode | flagIcon }}"></span>
            <span class="currency-code">{{ tradeDrawdownCurrent?.sellCurrencyCode }}</span>
            <span>{{ tradeDrawdownCurrent?.sellAmount }}</span>
        </div>
    </div>

    <div class="col-12 col-md-6 trade-drawdown right-panel pr-0">
        <div class="drawdown-title">
            On this date
        </div>
        <div class="drawdown-value d-flex align-items-center">
            {{ paymentModel.paymentDate | date: 'dd/MM/yyyy' }}
            <img class="ml-auto" src="./assets/images/icon-png/calendar_icon.svg" alt="" />
        </div>
    </div>
</div>
<div class="row">
    <p class="text-dark-blue text-footer">Please refer to your Trade history to drawdown your confirmations.</p>
</div>
<div class="row">
    <div class="col-4 pl-0">
        <button class="btn btn-block btn-lg btn-greengo-o" (click)="backTabDrawdown()">Back</button>
    </div>
    <div class="col-4 ml-auto pr-0">
        <button class="btn btn-block btn-lg btn-greengo" (click)="nextTabDrawdown()">Next</button>
    </div>
</div>
<!-- </div> -->